import { put, takeLatest, call } from 'redux-saga/effects';
import { AnalyticsApi, PatientAnalyticsResponse } from '../../api/services/analytics';
import {
  fetchPatientAnalytics,
  fetchPatientAnalyticsSuccess,
  fetchPatientAnalyticsFailure,
} from '../slices/analyticsSlice';

// Fetch patient analytics
function* fetchPatientAnalyticsSaga() {
  try {
    const response: PatientAnalyticsResponse = yield call(AnalyticsApi.getPatientAnalytics);
    if (response && response.data) {
      yield put(fetchPatientAnalyticsSuccess(response.data));
    } else {
      yield put(fetchPatientAnalyticsFailure('Failed to fetch patient analytics'));
    }
  } catch (error) {
    yield put(
      fetchPatientAnalyticsFailure(
        error instanceof Error ? error.message : 'An unknown error occurred'
      )
    );
  }
}

// Root saga combining all analytics sagas
export function* watchAnalyticsActions() {
  yield takeLatest(fetchPatientAnalytics.type, fetchPatientAnalyticsSaga);
}
